//-----------------
// is numeric
//-----------------
export default function isNumeric(e) {
  let regex = null;
  //-----------------------
  // allow delete/bsp keys
  //-----------------------
  if (e.key === "Delete" || e.key === "Backspace") {
    return true;
  }
  //----------------------
  // prevent command keys
  //----------------------
  if (e.shiftKey || e.ctrlKey || e.option || e.altKey) {
    return false;
  }
  //----------------------
  // else only accept 0-9
  //----------------------
  regex = new RegExp("[0-9]");
  //------------------
  // obtain key value
  //------------------
  var key = e.keyCode || e.which;
  key = String.fromCharCode(key);
  //-----------------
  // check key value
  //-----------------
  if (!regex.test(key)) {
    return false;
  } else {
    return true;
  }
}
